import React, {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useState,
} from 'react'
import { ItemState, UseItem } from '@components/ItemPage/utils/types'
import useItem from '../../../hooks/useItem'
import useModals from '@components/ItemPage/Modals/useModals'
import useUpdatedItems from '../../../hooks/useUpdatedItems'
import { DEFAULT_ITEM_PAGE_OBJECT } from '@components/ItemPage/utils/constants'

interface ItemPageContextType {
  itemState: ItemState
  setItemState: Dispatch<SetStateAction<ItemState>>
  itemHandler: any
  modal: {
    state: any
    handlers: any
    refs: any
  }
  lastUpdated: any // Consider providing a more specific type
  infoSlideOutOpen: boolean
  setInfoSlideOutOpen: Dispatch<SetStateAction<boolean>>
  auction: any
  pageNumber: number
}

const ItemPageContext = createContext<ItemPageContextType>(
  DEFAULT_ITEM_PAGE_OBJECT
)
const ItemPageProvider = ({
  auctionItem,
  allOffers,
  itemId,
  fetchItemUrl,
  auction,
  children,
  pageNumber,
}: any) => {
  const { itemState, setItemState, itemHandler }: UseItem = useItem(auctionItem)
  const modal = useModals({ allOffers, itemId, auctionItem })
  const [_a, _b, { lastUpdated }] = useUpdatedItems({
    url: fetchItemUrl,
    initialData: auctionItem,
    handleState: (data: [ItemState]) =>
      setItemState((prevState) => ({ ...prevState, ...data[0] })),
    initialLoadingState: true,
    isRefreshDisabled: auctionItem.itemClosed,
  })
  const [infoSlideOutOpen, setInfoSlideOutOpen] = useState<any>(false)

  const value = {
    itemState,
    setItemState,
    itemHandler,
    modal,
    lastUpdated,
    infoSlideOutOpen,
    setInfoSlideOutOpen,
    auction,
    pageNumber,
  }

  return (
    <ItemPageContext.Provider value={value}>
      {children}
    </ItemPageContext.Provider>
  )
}

export const useItemPage = (): ItemPageContextType => {
  const context = useContext(ItemPageContext)
  if (context === undefined) {
    throw new Error('useItemPageContext must be used within a ItemPageProvider')
  }
  return context
}

export default ItemPageProvider
